import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { SITE } from "@/data/site";
import { MapPin } from "lucide-react";

export default function About() {
  return (
    <main data-testid="about-page" className="pt-24 md:pt-32 pb-24">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chapter-index text-emerald-700">About · {SITE.legal}</p>
        <h1 className="font-display text-5xl md:text-8xl leading-[0.92] mt-3 max-w-4xl">Built in Bhuj. <span className="italic text-emerald-800">Backing India's next mile.</span></h1>
      </section>

      <section className="mt-14 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
        <div className="rounded-3xl overflow-hidden aspect-[4/3] clip-frame">
          <img src="https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Warehouse logistics" className="w-full h-full object-cover"/>
        </div>
        <div>
          <p className="chapter-index text-emerald-700">— Our story</p>
          <h2 className="font-display text-4xl md:text-5xl mt-3 leading-tight">A finance partner shaped by the operators we serve.</h2>
          <p className="mt-6 text-slate-600 leading-relaxed">Rightway Finance was founded in Kutch — a region that literally moves India. Every day, thousands of trucks, tractors and pickups leave Bhuj and Mundra with cargo destined for the length of the country. Our operators are our neighbours. Our job is to make the finance behind those journeys feel simple, transparent and human.</p>
          <blockquote className="mt-8 font-display text-2xl md:text-3xl italic text-slate-900 border-l-2 border-emerald-700 pl-6">"We don't just finance vehicles. We build entrepreneurs."</blockquote>
        </div>
      </section>

      <section className="mt-24 bg-[hsl(222_47%_11%)] text-white py-24 grain relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="chapter-index text-emerald-400">— What we stand for</p>
          <h2 className="font-display text-4xl md:text-6xl mt-3 max-w-3xl leading-tight">Four principles that shape every application.</h2>
          <div className="mt-12 grid md:grid-cols-2 gap-x-16 gap-y-12">
            {[
              ["01", "Transparency", "No hidden fees. Every clause spelled out before you sign."],
              ["02", "Access", "51+ bank & NBFC partners so borrowers get best-fit offers."],
              ["03", "Advocacy", "A named advisor for every applicant. Not a call centre."],
              ["04", "Discipline", "We only recommend loans that are structurally sound for your business."],
            ].map(([n, t, d]) => (
              <div key={n} className="border-t border-white/15 pt-6">
                <p className="chapter-index text-emerald-400">— {n}</p>
                <p className="font-display text-3xl mt-2">{t}</p>
                <p className="mt-2 text-slate-300 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <p className="chapter-index text-emerald-700">— Branches</p>
        <h2 className="font-display text-4xl md:text-6xl mt-3">Kutch, and beyond.</h2>
        <div className="mt-8 grid md:grid-cols-3 gap-6">
          {SITE.branches.map((b) => (
            <div key={b} className="rounded-3xl border border-black/[0.06] bg-white p-6">
              <MapPin className="text-emerald-700" size={18}/>
              <p className="font-display text-3xl mt-3">{b}</p>
              <p className="text-sm text-slate-500 mt-1">Gujarat, India</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
